// extracted by mini-css-extract-plugin
export default {"root":"classes_root__7RCPK","icon":"classes_icon__AHwPp","number":"classes_number__sCCED"};